<template>
  <div class="forbidden-channel">
    <v-container fluid>
      <v-row>
        <v-col cols="12" align="center">
          <img :src="require('@/assets/sem_acesso.png')" alt="Sem acesso à este canal" />
        </v-col>
        <h2 class="pt-6">Ops, você não tem acesso a esse canal</h2>
        <v-col cols="12" align="center">
          <p>Para mais informações, consulte seu consultor Mercafacil.</p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'ForbiddenChannel',
}
</script>

<style lang="scss" scoped>
.forbidden-channel {
  & img {
    width: 200px;
  }
  & h2 {
    font-weight: bold;
    font-size: 24px;
    line-height: 120%;
    color: $cinza-0;
    display: block;
    text-align: center;
    width: 100%;
  }

  & p {
    margin: 0;
    font-weight: normal;
    font-size: 20px;
    line-height: 120%;
    text-align: center;
    color: $cinza-0;
    max-width: 500px;
    display: block;
    text-align: center;
  }
}
</style>
